"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POSTS_PER_LISTING_PAGE_OUT_OF_RANGE = exports.POSTS_PER_FEED_OUT_OF_RANGE = exports.REDIRECT_EXISTS = exports.PAGE_EXISTS = exports.FAILED_TO_UPDATE_SLUGS_WITH_NEW_ROOT_DATA_TRUNCATED = exports.CONTENT_GROUP_URL_CHANGE_CONFLICT = exports.BLOG_MISSING_LISTING_TEMPLATE = exports.BLOG_MISSING_ITEM_TEMPLATE = exports.BLOG_DOMAINS_ENTERPRISE_ONLY = exports.BLOG_URL_EXISTS = exports.BLOG_SLUG_TOO_LONG = exports.BLOG_NAME_TOO_LONG = exports.BLOG_NAME_NO_HTML = exports.BLOG_NAME_MISSING = exports.BLOG_NAME_EXISTS = void 0;
var BLOG_NAME_EXISTS = 'BLOG_NAME_EXISTS';
exports.BLOG_NAME_EXISTS = BLOG_NAME_EXISTS;
var BLOG_NAME_MISSING = 'BLOG_NAME_MISSING';
exports.BLOG_NAME_MISSING = BLOG_NAME_MISSING;
var BLOG_NAME_NO_HTML = 'BLOG_NAME_NO_HTML';
exports.BLOG_NAME_NO_HTML = BLOG_NAME_NO_HTML;
var BLOG_NAME_TOO_LONG = 'BLOG_NAME_TOO_LONG';
exports.BLOG_NAME_TOO_LONG = BLOG_NAME_TOO_LONG;
var BLOG_SLUG_TOO_LONG = 'BLOG_SLUG_TOO_LONG';
exports.BLOG_SLUG_TOO_LONG = BLOG_SLUG_TOO_LONG;
var BLOG_URL_EXISTS = 'BLOG_URL_EXISTS';
exports.BLOG_URL_EXISTS = BLOG_URL_EXISTS;
var BLOG_DOMAINS_ENTERPRISE_ONLY = 'BLOG_DOMAINS_ENTERPRISE_ONLY';
exports.BLOG_DOMAINS_ENTERPRISE_ONLY = BLOG_DOMAINS_ENTERPRISE_ONLY;
var BLOG_MISSING_ITEM_TEMPLATE = 'BLOG_MISSING_ITEM_TEMPLATE';
exports.BLOG_MISSING_ITEM_TEMPLATE = BLOG_MISSING_ITEM_TEMPLATE;
var BLOG_MISSING_LISTING_TEMPLATE = 'BLOG_MISSING_LISTING_TEMPLATE';
exports.BLOG_MISSING_LISTING_TEMPLATE = BLOG_MISSING_LISTING_TEMPLATE;
var CONTENT_GROUP_URL_CHANGE_CONFLICT = 'CONTENT_GROUP_URL_CHANGE_CONFLICT';
exports.CONTENT_GROUP_URL_CHANGE_CONFLICT = CONTENT_GROUP_URL_CHANGE_CONFLICT;
var FAILED_TO_UPDATE_SLUGS_WITH_NEW_ROOT_DATA_TRUNCATED = 'FAILED_TO_UPDATE_SLUGS_WITH_NEW_ROOT_DATA_TRUNCATED';
exports.FAILED_TO_UPDATE_SLUGS_WITH_NEW_ROOT_DATA_TRUNCATED = FAILED_TO_UPDATE_SLUGS_WITH_NEW_ROOT_DATA_TRUNCATED;
var PAGE_EXISTS = 'PAGE_EXISTS';
exports.PAGE_EXISTS = PAGE_EXISTS;
var REDIRECT_EXISTS = 'REDIRECT_EXISTS';
exports.REDIRECT_EXISTS = REDIRECT_EXISTS;
var POSTS_PER_FEED_OUT_OF_RANGE = 'POSTS_PER_FEED_OUT_OF_RANGE';
exports.POSTS_PER_FEED_OUT_OF_RANGE = POSTS_PER_FEED_OUT_OF_RANGE;
var POSTS_PER_LISTING_PAGE_OUT_OF_RANGE = 'POSTS_PER_LISTING_PAGE_OUT_OF_RANGE';
exports.POSTS_PER_LISTING_PAGE_OUT_OF_RANGE = POSTS_PER_LISTING_PAGE_OUT_OF_RANGE;